module.exports = __webpack_public_path__ + "static/aws-9d0493437c0b9cd5bb3fd26b2145c378.png";